import ToolbarItem from "toolbar/ToolbarItem";

class ToolbarItemBasic extends ToolbarItem {

    constructor(text, onClick, icon = '', active = false) {
        super();
        this.text = text;
        this.onClick = onClick;
        this.icon = icon;
        this.active = active;
    }

    handleClick() {
        return this.onClick.apply(this, arguments) === true;
    }

    getText() {
        return this.text;
    }
}

export default ToolbarItemBasic;
